
import { IInstallationsResult, StatisticsService } from "@/services/statistics-service";
import { ApexOptions } from "apexcharts";
import Vue from "vue";
export default Vue.extend({
	data(){
		let beginDate = new Date();
		beginDate.setFullYear(beginDate.getFullYear()-1);
		return {
			initialSeries: [] as any[],
			items: {
				totalStarter: [], totalProf: [], totalEnt: [], totalAll: [],
				newStarters: [], newEnts: [], newProfs: [], newAll: [],
				diffStarter: [], diffProf: [], diffEnt: [], diffAll: []
			} as IInstallationsResult,
			beginDate,
			endDate: new Date(),
			onlyCreatedByWfOnline: false,
			showAll: true,
			showStarters: true,
			showProfs: true,
			showEnterprises: true
		};
	},
	computed: {
		now():Date{
			return new Date();
		},
		// eslint-disable-next-line max-lines-per-function
		chartOptions(): ApexOptions {
			let ref = this;
			return {
				chart: {},
				xaxis: {
					labels: {
						show: true,
						formatter(value: string): string {
							let numericValue = parseInt(value || "0") - 1;
							let date = new Date(ref.beginDate);
							date.setDate(date.getDate() + numericValue * 7);
							let year = `${date.getFullYear()}`.substring(2);
							let month = `${date.getMonth()+1}`;
							if (month.length == 1) {
								month = `0${month}`;
							}
							let day = `${date.getDate()}`;
							if (day.length == 1) {
								day = `0${day}`;
							}
							return `${day}/${month}/${year}`;
						},
						rotateAlways: true
					},
					title: {
						text: "Week"
					}
				},
				yaxis: {
					title: {
						text: "Aantal"
					},
					min: 0,
					tickAmount: 1,
					forceNiceScale: true
				},
				dataLabels: {
					enabled: false
				}
			};
		}
	},
	methods: {
		async fetch(){
			this.items = await StatisticsService.getInstallations(this.beginDate, this.endDate, this.onlyCreatedByWfOnline);
			this.updateData();
		},
		updateData() {
			if (this.$refs.chartTotal) {
				(this.$refs.chartTotal as any).updateSeries(this.getTotalSeries());
			}
			if (this.$refs.chartNew) {
				(this.$refs.chartNew as any).updateSeries(this.getNewSeries());
			}
			if (this.$refs.chartDiff){
				(this.$refs.chartDiff as any).updateSeries(this.getDiffSeries());
			}
		},
		getTotalSeries() {
			let result:{name:string, data:number[]}[] = [];
			if (this.showStarters){
				result.push({name: "Starters",data: this.items.totalStarter});
			}
			if (this.showProfs) {
				result.push({name: "Profs",data: this.items.totalProf});
			}
			if (this.showEnterprises){
				result.push({name: "Enterprises", data: this.items.totalEnt});
			}
			if (this.showAll) {
				result.push({name: "Alle", data: this.items.totalAll});
			}
			return result;
		},
		getNewSeries(){
			let result:{name:string, data:number[]}[] = [];
			if (this.showStarters){
				result.push({name: "Starters",data: this.items.newStarters});
			}
			if (this.showProfs) {
				result.push({name: "Profs",data: this.items.newProfs});
			}
			if (this.showEnterprises){
				result.push({name: "Enterprises", data: this.items.newEnts});
			}
			if (this.showAll) {
				result.push({name: "Alle", data: this.items.newAll});
			}
			return result;
		},
		getDiffSeries(){
			let result:{name:string, data:number[]}[] = [];
			if (this.showStarters){
				result.push({name: "Starters",data: this.items.diffStarter});
			}
			if (this.showProfs) {
				result.push({name: "Profs",data: this.items.diffProf});
			}
			if (this.showEnterprises){
				result.push({name: "Enterprises", data: this.items.diffEnt});
			}
			if (this.showAll) {
				result.push({name: "Alle", data: this.items.diffAll});
			}
			return result;
		},
		setBeginDate(date:Date){
			this.beginDate = date;
			this.fetch();
		},
		setEndDate(date:Date){
			this.endDate = date;
			this.fetch();
		},
		onOnlyCreatedByWfOnlineToggle(value:boolean) {
			this.onlyCreatedByWfOnline = value;
			this.fetch();
		},
		setShowAll(value:boolean){
			this.showAll = value;
			this.updateData();
		},
		setShowStarters(value:boolean){
			this.showStarters = value;
			this.updateData();
		},
		setShowProfs(value:boolean){
			this.showProfs = value;
			this.updateData();
		},
		setShowEnterprises(value:boolean){
			this.showEnterprises = value;
			this.updateData();
		},
	},
	async mounted(){
		await this.fetch();
	}
});
